import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { initializeAuth } from '../../store/actions/authThunks';

/**
 * This component initializes the authentication state of the application.
 * It dispatches the initializeAuth thunk on mount to verify and set up the user's session.
 *
 * Purpose:
 * Ensures that authentication data (e.g., tokens and user information) is validated
 * and loaded into the Redux store before rendering the application.
 */
const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  return children;
};

export default AppInitializer;
